// extracted by mini-css-extract-plugin
module.exports = {"flexRow":"services-module--flexRow--22caT"};